import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsArray,
  ArrayNotEmpty,
  IsUUID,
  IsOptional,
  IsDateString,
  IsInt,
  Min,
  IsBoolean,
} from 'class-validator'
import { Type } from 'class-transformer'

export class BulkTeachingAssignmentsDto {
  @ApiProperty({
    description: "UUID de l'activité à assigner",
  })
  @IsUUID('4')
  activityId!: string

  @ApiProperty({
    description: 'Liste des enseignements cibles',
    type: [String],
  })
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID('4', { each: true })
  teachingIds!: string[]

  @ApiPropertyOptional({ description: 'Date de disponibilité (ISO 8601)' })
  @IsOptional()
  @IsDateString()
  availableFrom?: string

  @ApiPropertyOptional({ description: "Date d'échéance (ISO 8601)" })
  @IsOptional()
  @IsDateString()
  dueAt?: string

  @ApiPropertyOptional({ description: 'Nombre max de tentatives' })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  maxAttempts?: number

  @ApiPropertyOptional({ description: 'Afficher les solutions' })
  @IsOptional()
  @IsBoolean()
  showSolutions?: boolean

  @ApiPropertyOptional({ description: "Randomiser l'ordre des questions" })
  @IsOptional()
  @IsBoolean()
  randomizeOrder?: boolean

  @ApiPropertyOptional({ description: 'Visible' })
  @IsOptional()
  @IsBoolean()
  isVisible?: boolean
}
